@if (metodos) {
<div class="requisicao-panel">
  <app-select-one
    label="Método"
    widthFormField="100%"
    heightFormField="35px"
    [listaInput]="metodos"
    [itemSelecionado]="selectedNode?.requisicao?.metodo"
    (selecionarItem)="
      selecionarMetodo($event);
      alteracaoService.camposAlterado();
    "
  ></app-select-one>

  <app-select-multiple
    [listaInput]="variaveisDoFluxoSelect"
    [itensSelecionado]="variaveisSelecionadas"
    [font]="'12px'"
    heightFormField="35px"
    campo="nome"
    (selecionarItem)="selecionarVariaveis($event)"
    colorLabel="black"
    label="Variáveis que serão enviadas!"
  ></app-select-multiple>

  <app-form-field
    label="URL"
    placeholder="https://api.exemplo.com"
    heightFormField="35px"
    [value]="selectedNode?.requisicao?.url"
    (changeValue)="onUrlChange($event)"
  ></app-form-field>

  @if (metodosComCorpo.includes(selectedNode?.requisicao?.metodo ?? '')) {
  <app-select-one
    label="Content-Type"
    widthFormField="100%"
    heightFormField="35px"
    [listaInput]="tiposConteudos"
    [itemSelecionado]="selectedNode?.requisicao?.contentType"
    (selecionarItem)="
      selectedNode!.requisicao!.contentType = $event;
      alteracaoService.camposAlterado()
    "
  ></app-select-one>

  <span class="label">Corpo da Requisição</span>
    <textarea
    [ngModel]="selectedNode?.requisicao?.corpo"
    (ngModelChange)="onCorpoChange($event)"
    rows="4"
    placeholder='Ex: {"chave": "valor"}'
  ></textarea>
  }

  <div class="flex justify-between align-center">
    <span class="label">Cabeçalhos</span>
    <app-button-padrao
      icon="add"
      width="25px"
      height="25px"
      (buttonClick)="adicionarCabecalho()"
    ></app-button-padrao>
  </div>

  @for (cabecalho of selectedNode?.requisicao?.cabecalhos; track $index) {
  <app-form-field
    placeholder="Chave"
    heightFormField="35px"
    [value]="cabecalho.chave"
    (changeValue)="
      cabecalho.chave = $event; alteracaoService.camposAlterado()
    "
  ></app-form-field>
  <app-form-field
    placeholder="Valor"
    heightFormField="35px"
    [value]="cabecalho.valor"
    (changeValue)="
      cabecalho.valor = $event; alteracaoService.camposAlterado()
    "
  ></app-form-field>
  <app-button-padrao
    icon="delete_forever"
    width="25px"
    height="25px"
    (buttonClick)="removerCabecalho($index)"
  ></app-button-padrao>
  }

  <div class="flex justify-between align-center">
    <span class="label">Parâmetros</span>
    <app-button-padrao
      icon="add"
      width="25px"
      height="25px"
      (buttonClick)="adicionarParametro()"
    ></app-button-padrao>
  </div>

  @for (parametro of selectedNode?.requisicao?.parametros; track $index) {
  <app-form-field
    placeholder="Nome"
    heightFormField="35px"
    [value]="parametro.nome"
    (changeValue)="parametro.nome = $event; alteracaoService.camposAlterado()"
  ></app-form-field>
  <app-form-field
    placeholder="Valor"
    heightFormField="35px"
    [value]="parametro.valor"
    (changeValue)="
      parametro.valor = $event; alteracaoService.camposAlterado()
    "
  ></app-form-field>

  <app-select-one
    label="Tipo"
    widthFormField="100%"
    heightFormField="35px"
    [listaInput]="tiposParametros"
    [itemSelecionado]="parametro.tipo"
    (selecionarItem)="
      parametro.tipo = $event; alteracaoService.camposAlterado()
    "
  ></app-select-one>
  <app-button-padrao
    icon="delete_forever"
    width="25px"
    height="25px"
    (buttonClick)="removerParametro($index)"
  ></app-button-padrao>
  } @if(isRequisicaoRetorno){
    <div class="flex justify-between align-center gap-5 width-100">
    <app-select-one
      style="width: 100%;"
      label="Retorno da Requisição"
      widthFormField="100%"
      heightFormField="35px"
      [listaInput]="tiposRetornos"
      [itemSelecionado]="selectedNode?.requisicao?.tipoRetorno || null"
      (selecionarItem)="selecionarTipoRetorno($event)"
    ></app-select-one>

    @if (selectedNode?.requisicao?.tipoRetorno) {
      <app-button-padrao
        icon="data_object"
        style="margin-top: 20px;"
        fontSize="20px"
        matTooltip="Ver Retorno Esperado!"
        (buttonClick)="abrirModalExemplo(selectedNode?.requisicao?.tipoRetorno!)"
      >
      </app-button-padrao>
    }
  </div>
  }
</div>
}
